import { Anitbiotikadubblett } from 'src/app/shared/models/manuell-atgard';
import { NameStatus } from '../../shared/models/models';

export interface AnalysResultat {
  provId: string;
  antalFynd: string;
  ankomst_datum: Date;
  lab: string;
  dag_i_inskicksperiod?: number;
  numberOfUnknown?: string;
  gender?: string;
  id: string;
}
export interface AnalysResultatDTO {
  analysName: string;
  analys_status: string;
  ignored: boolean;
  provId: string;
  id: string;
  synName: string;
  nameStatus: NameStatus;
  flodeStatus: string;
  remiss_ar: string;
  forekomst_nr?: number;
  antalFynd: string;
  ankomst_datum: string;
  labCode: string;
  dag_i_inskicksperiod: number;
  numberOfUnknown?: string;
  provdata: ProvData;
  fyndList: Fynd[];
  gender?: string;
  lab?: string;
  parked: boolean;
}

export interface AnalysResultatDetailsDTO {
  analysNamn: string;
  analys_status: string;
  ignorerad: boolean;
  provId: string;
  id: string;
  syn_namn: string;
  namnStatus: string;
  flodeStatus: string;
  remiss_ar: string;
  forekomst_nr: number;
  antalFynd: string;
  ankomst_datum: Date;
  labCode: string;
  dag_i_inskicksperiod: number;
  numberOfUnknown?: string;
  gender?: string;
}

export interface ProvData {
  ankomst_datum: Date;
  bestallare: string;
  ignored: boolean;
  nameStatus: NameStatus;
  provId: string;
  provLabbRemissAr: string;
  provmaterialName: string;
  provtagnings_datum: Date;
  synName: string;
  parked: boolean;
}

export interface Fynd {
  fyndType: NameStatus;
  smittamneName: string;
  smittamneId: string;
  synName: string;
  synNegativFynd: string;
  num: number;
  ignored: boolean;
  nameStatus: NameStatus;
  nameStatusNegativFynd: NameStatus;
  antimicroList: Antibiotika[];
  parked?: boolean;
}

export interface Antibiotika {
  id: null;
  name: string;
  nameStatus: NameStatus;
  ignored: boolean;
  parked?: boolean;
  diskStyrka?: string;
  prim: number;
  sir?: string;
  zon?: number;
  mic?: number;
  tolk?: string;
  synName: string;
  antibiotikumDubblett: Anitbiotikadubblett;
}

export enum Gender {
  EJ_ANGIVET = '0',
  MAN = '1',
  KVINNA = '2',
  OKANT = '3',
}
export interface SearchDTO {
  analys?: string[];
  provMaterial?: string[];
  smittamne?: string[];
  labb?: string[];
  fullYear?: number;
  sampleDateEnd?: number;
  sampleDateStart?: string;
  positive?: boolean;
  gender?: Gender[];
  ageSpan?: number[];
  antibiotics?: string[];
  ageIntervalStandard?: AgeIntervalStandard;
  searchType?: SearchType;
  sortBy?: SortBy[];
  offset?: number;
  countSearch?: string[];
  [key: string]: any;
}

export enum AgeIntervalStandard {
  GLASS = 'GLASS',
  SWEDRED = 'SWEDRES',
  FOHM = 'FOHM'
}

export interface SortBy {
  name: string;
  order: string;
}

export interface ResistanceCalculationResultDTO {
  antibioticName: string;
  total: number;
  total_sir: number;
  total_tolk: number;
  sir_s: number;
  sir_i: number;
  sir_r: number;
  tolk_s: number;
  tolk_i: number;
  tolk_r: number;
  sir_s_percent: number;
  sir_i_percent: number;
  sir_r_percent: number;
  tolk_s_percent: number;
  tolk_i_percent: number;
  tolk_r_percent: number;
}

export enum SearchType {
  SPECIFIC,
  GENERAL,
  NAMNARDATA
}
